import styled from 'styled-components'
import { Breadcrumb as BreadcrumbUI } from '@navent-jobs/ui-kit/components/breadcrumb'

export const BreadcrumbContainer = styled('div')`
  background-color: ${({ isDesktopOrTabletLandscape, theme }) =>
    !isDesktopOrTabletLandscape ? theme.colors.grey0 : 'transparent'};
  padding: 32px 0px 0px;
  margin-top: 24px;

  strong {
    font-weight: 600;
  }

  @media (min-width: 1017px) {
    padding: 0;
    padding-bottom: 16px;
    margin-top: 0;
    background-color: transparent;
  }
`

export const BreadcrumbComponent = styled(BreadcrumbUI)`
  padding: 0px;
  align-items: start;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    display: block;
  }
`
